"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
document.addEventListener("turbo:load", () => {
  const $modal = $("#show-email-modal");
  if ($modal.length === 0) {
    return;
  }
  const $button = $("[data-open=user_email]", $modal);
  const $email = $("#user_email", $modal);
  const $fullName = $("#user_full_name", $modal);
  $("[data-dialog-open=show-email-modal]").on("click", (event) => {
    event.preventDefault();
    $button.show();
    $button.attr("data-remote-url", event.currentTarget.href);
    $fullName.text($(event.currentTarget).data("full-name"));
    $email.html("");
  });
  function getUserEmail(url) {
    return __async(this, null, function* () {
      let response = yield fetch(url);
      if (response.ok) {
        let userEmail = yield response.text();
        $("#user_email").html(userEmail);
        $button.hide();
      } else {
        console.log(`Error-HTTP: " + ${response.status}`);
      }
    });
  }
  $("[data-open=user_email]").on("click", (event) => {
    getUserEmail(event.currentTarget.dataset.remoteUrl);
  });
});
